module.exports = __webpack_public_path__ + "img/no.680118c0.svg";